var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 18,
    viewBox: "0 0 140 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 18,
    rx: 4,
    fill: "url(#paint0_linear_854_3757)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5245 3.46352C14.6741 3.00287 15.3259 3.00287 15.4755 3.46353L16.4593 6.49139C16.5263 6.6974 16.7183 6.83688 16.9349 6.83688H20.1186C20.6029 6.83688 20.8043 7.45669 20.4124 7.74139L17.8368 9.61271C17.6615 9.74003 17.5882 9.96572 17.6552 10.1717L18.639 13.1996C18.7886 13.6602 18.2614 14.0433 17.8695 13.7586L15.2939 11.8873C15.1186 11.76 14.8814 11.76 14.7061 11.8873L12.1305 13.7586C11.7386 14.0433 11.2114 13.6602 11.361 13.1996L12.3448 10.1717C12.4118 9.96572 12.3385 9.74003 12.1632 9.61271L9.58755 7.74139C9.1957 7.45669 9.39708 6.83688 9.88145 6.83688H13.0651C13.2817 6.83688 13.4737 6.6974 13.5407 6.49139L14.5245 3.46352Z",
    fill: "url(#paint1_linear_854_3757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5245 3.46352C30.6741 3.00287 31.3259 3.00287 31.4755 3.46353L32.4593 6.49139C32.5263 6.6974 32.7183 6.83688 32.9349 6.83688H36.1186C36.6029 6.83688 36.8043 7.45669 36.4124 7.74139L33.8368 9.61271C33.6615 9.74003 33.5882 9.96572 33.6552 10.1717L34.639 13.1996C34.7886 13.6602 34.2614 14.0433 33.8695 13.7586L31.2939 11.8873C31.1186 11.76 30.8814 11.76 30.7061 11.8873L28.1305 13.7586C27.7386 14.0433 27.2114 13.6602 27.361 13.1996L28.3448 10.1717C28.4118 9.96572 28.3385 9.74003 28.1632 9.61271L25.5876 7.74139C25.1957 7.45669 25.3971 6.83688 25.8814 6.83688H29.0651C29.2817 6.83688 29.4737 6.6974 29.5407 6.49139L30.5245 3.46352Z",
    fill: "url(#paint2_linear_854_3757)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5245 3.46352C46.6741 3.00287 47.3259 3.00287 47.4755 3.46353L48.4593 6.49139C48.5263 6.6974 48.7183 6.83688 48.9349 6.83688H52.1186C52.6029 6.83688 52.8043 7.45669 52.4124 7.74139L49.8368 9.61271C49.6615 9.74003 49.5882 9.96572 49.6552 10.1717L50.639 13.1996C50.7886 13.6602 50.2614 14.0433 49.8695 13.7586L47.2939 11.8873C47.1186 11.76 46.8814 11.76 46.7061 11.8873L44.1305 13.7586C43.7386 14.0433 43.2114 13.6602 43.361 13.1996L44.3448 10.1717C44.4118 9.96572 44.3385 9.74003 44.1632 9.61271L41.5876 7.74139C41.1957 7.45669 41.3971 6.83688 41.8814 6.83688H45.0651C45.2817 6.83688 45.4737 6.6974 45.5407 6.49139L46.5245 3.46352Z",
    fill: "url(#paint3_linear_854_3757)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5245 3.46352C62.6741 3.00287 63.3259 3.00287 63.4755 3.46353L64.4593 6.49139C64.5263 6.6974 64.7183 6.83688 64.9349 6.83688H68.1186C68.6029 6.83688 68.8043 7.45669 68.4124 7.74139L65.8368 9.61271C65.6615 9.74003 65.5882 9.96572 65.6552 10.1717L66.639 13.1996C66.7886 13.6602 66.2614 14.0433 65.8695 13.7586L63.2939 11.8873C63.1186 11.76 62.8814 11.76 62.7061 11.8873L60.1305 13.7586C59.7386 14.0433 59.2114 13.6602 59.361 13.1996L60.3448 10.1717C60.4118 9.96572 60.3385 9.74003 60.1632 9.61271L57.5876 7.74139C57.1957 7.45669 57.3971 6.83688 57.8814 6.83688H61.0651C61.2817 6.83688 61.4737 6.6974 61.5407 6.49139L62.5245 3.46352Z",
    fill: "url(#paint4_linear_854_3757)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5245 3.46352C78.6741 3.00287 79.3259 3.00287 79.4755 3.46353L80.4593 6.49139C80.5263 6.6974 80.7183 6.83688 80.9349 6.83688H84.1186C84.6029 6.83688 84.8043 7.45669 84.4124 7.74139L81.8368 9.61271C81.6615 9.74003 81.5882 9.96572 81.6552 10.1717L82.639 13.1996C82.7886 13.6602 82.2614 14.0433 81.8695 13.7586L79.2939 11.8873C79.1186 11.76 78.8814 11.76 78.7061 11.8873L76.1305 13.7586C75.7386 14.0433 75.2114 13.6602 75.361 13.1996L76.3448 10.1717C76.4118 9.96572 76.3385 9.74003 76.1632 9.61271L73.5876 7.74139C73.1957 7.45669 73.3971 6.83688 73.8814 6.83688H77.0651C77.2817 6.83688 77.4737 6.6974 77.5407 6.49139L78.5245 3.46352Z",
    fill: "url(#paint5_linear_854_3757)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_854_3757",
    x1: 6.51925e-7,
    y1: 9.00001,
    x2: 136,
    y2: 9.00002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7FFE7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_854_3757",
    x1: 15,
    y1: 2,
    x2: 15,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEAE02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_854_3757",
    x1: 31,
    y1: 2,
    x2: 31,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEAE02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_854_3757",
    x1: 47,
    y1: 2,
    x2: 47,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEAE02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_854_3757",
    x1: 63,
    y1: 2,
    x2: 63,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEAE02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_854_3757",
    x1: 79,
    y1: 2,
    x2: 79,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEAE02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.26ea899eeb2022c74db3acc89b8e79e6.svg";
export { ForwardRef as ReactComponent };